import PullObjectsHS from '@v2/components/flowsteps/editors/PullOjbectHS/PullObjectsHS';
import { PushObjectsHS } from '@v2/components/flowsteps/editors/PushObjectsHS/PushObjectsHS';
import { DeleteObjectsHS } from '@v2/components/flowsteps/editors/DeleteObjectsHS/DeleteObjectsHS';
import { inject, observer } from 'mobx-react';
import qs from 'qs';
import React from 'react';
import { Route, Switch, useLocation, useRouteMatch } from 'react-router-dom';
import { Operation, ProviderType } from 'shared/types/flowstep';
import { FlowstepType, FlowstepV2Types } from 'shared/utils/flowstep';
import Page from 'src/components/base/Page';
import * as Editor from 'src/components/Flowsteps/flowsteps';
import { PullHubspotList } from "@v2/components/flowsteps/editors/hubspot/list/PullHubspotList/PullHubspotList";

const FlowstepsData = {
  soql: { title: 'Run SOQL Query', editor: Editor.Soql },
  csv: { title: 'Download CSV file', editor: Editor.Csv },
  sosl: { title: 'Run SOSL Query', editor: Editor.Sosl },
  report: { title: 'Reports', editor: Editor.Reports },
  delete: { title: 'Delete Data', editor: Editor.DeleteData },
  undelete: { title: 'Undelete Data', editor: Editor.UndeleteData },
  insert: { title: 'Insert Data', editor: Editor.InsertData },
  update: { title: 'Modify Data', editor: Editor.UpdateData },
  upsert: { title: 'Upsert Data', editor: Editor.UpsertData },
  'convert-leads': { title: 'Convert Leads', editor: Editor.ConvertLeads },
  'merge-objects': { title: 'Merge Objects', editor: Editor.MergeObjects },
}


const FlowstepRoute = ({ matchUrl, path, component, title, backTo, ...props }) => {
  const match = useRouteMatch(path);
  if (!match) { return null }


  const { search } = useLocation();
  const { range, createNew, flowId } = qs.parse(search, { ignoreQueryPrefix: true, });
  const { id } = match.params;
  return (
    <Page
      key={id} path={path} title={title} component={component} backTo={backTo}
      range={range} createNew={createNew === 'true'} flowId={flowId} {...props}
    />
  )
}

const FlowstepV2Route = ({ path, Component }) => {
  const match = useRouteMatch(path);
  if (!match) { return null }


  const { search } = useLocation();
  const { createNew, ...restParams } = qs.parse(search, { ignoreQueryPrefix: true, });
  const { id, operation } = match.params;

  return <Route path={path} render={() =>
    <Component id={id} createNew={createNew === 'true'} operation={operation} {...restParams} />
  } />
}


const Flowsteps = ({ match, userStore }) => {
  const { license } = userStore;

  return (
    <Switch>
      {Object.values(FlowstepType).filter(type => !FlowstepV2Types.includes(type)).map(type =>
        license.isFlowstepAvailable(type) &&
        <FlowstepRoute
          key={type}
          path={`${match.url}/${type}/:id?`}
          title={FlowstepsData[type].component}
          component={FlowstepsData[type].editor}
          backTo={null}
        />)}
      <FlowstepV2Route path={`${match.url}/${ProviderType.HS}/${Operation.PULL}/:id?`} Component={PullObjectsHS} />
      <FlowstepV2Route path={`${match.url}/${ProviderType.HS}/:operation(${Operation.INSERT}|${Operation.UPDATE})/:id?`} Component={PushObjectsHS} />
      <FlowstepV2Route path={`${match.url}/${ProviderType.HS}/${Operation.DELETE}/:id?`} Component={DeleteObjectsHS} />
      <FlowstepV2Route path={`${match.url}/${ProviderType.HubspotList}/${Operation.PULL}/:id?`} Component={PullHubspotList} />
    </Switch>
  );
}

export default inject('userStore')(observer(Flowsteps));
